/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { of as observableOf, Observable } from 'rxjs';
import { Camera, SecurityCamerasData } from '../../interfaces/iot/security-cameras';

@Injectable()
export class SecurityCamerasService extends SecurityCamerasData {

  public location = 'zaichevskoe';

  private cameras: Camera[] = [
    {
      title: 'Camera #1',
      source: `assets/images/${this.location}_camera1.jpg`,
    },
    {
      title: 'Camera #2',
      source: `assets/images/${this.location}_camera2.jpg`,
    },
    {
      title: 'Camera #3',
      source: `assets/images/${this.location}_camera3.jpg`,
    },
    {
      title: 'Camera #4',
      source: `assets/images/${this.location}_camera4.jpg`,
    },
  ];

  getCamerasData(): Observable<Camera[]> {
    console.log(this.cameras)
    return observableOf(this.cameras);
  }
}
